import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import useProgress from 'src/hook/data/useProgress';
import useUser from 'src/hook/data/useUser';
import { Actions, Guides } from 'src/model/enum/enums';
import { Guide } from "src/model/Guide";
import { guideActions } from 'src/store/slices/guideSlice';
import { RootState } from 'src/store/store';



export const useGuides = () => {

    const dispatch = useDispatch();
    const ac = bindActionCreators(guideActions, dispatch);
    const { visibleGuide } = useSelector((state: RootState) => state.guide);
    const { userInfo, updateUserInfo } = useUser();
    const { saveProgress } = useProgress();

    const showGuide = (guideType: Guides) => {
        if (userInfo?.Guides?.includes(guideType)) return;
        ac.showGuide(guideType);
        updateUserInfo({ Guides: [...userInfo?.Guides || [], guideType] });

        saveProgress({
            Action: Actions.SeenGuides,
            Value: guideType
        });
    };

    const hideGuide = () => {
        ac.hideGuide();
    };

    return {
        showGuide,
        hideGuide,
        visibleGuide,
    };
};

export type { Guide };

